function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".AddNode-1{fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "AddNode-1",
  d: "M0,13.16V15m7.5,0h3.8A9.37,9.37,0,0,0,30,14.2a9.82,9.82,0,0,0-9-9.47,9.36,9.36,0,0,0-9.7,8.43H7.5M21.56,9.41a.94.94,0,1,0-1.87,0v3.75H15.94a.94.94,0,1,0,0,1.87h3.75v3.75a.94.94,0,1,0,1.87,0V15h3.75a.94.94,0,1,0,0-1.87H21.56Z",
  transform: "translate(0 -4.72)"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.31,
  cy: 9.38,
  r: 4.31
});

var SvgAddNode = function SvgAddNode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AddNode_1",
    "data-name": "AddNode1",
    viewBox: "0 0 30 18.75",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddNode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AddNode.f29ccf20.svg";
export { ForwardRef as ReactComponent };